declare const Office: any;

/**
 * Send the selected content back to the Outlook add-in (which inserts it into the email
 * body) and close this dialog. Shared by every /outlook/* page and the compose override.
 */
export const postToOutlook = (payload: unknown) =>
  Office.onReady(() => {
    Office.context.ui.messageParent(JSON.stringify(payload), {
      targetOrigin: '*'
    });
    window.close();
  });
